import { z } from 'zod';
import { passwordSchema } from '../utils/password.utils.js';
export const loginSchema = z.object({
    email: z.email('Email invalide').min(1, 'Email requis'),
    password: z.string().min(1, 'Mot de passe requis'),
});
export const forgotPasswordSchema = z.object({
    email: z.email('Email invalide').min(1, 'Email requis'),
});
export const resetPasswordSchema = z
    .object({
    password: passwordSchema,
    confirmPassword: z.string().min(1, 'Veuillez confirmer votre mot de passe'),
})
    .refine((data) => data.password === data.confirmPassword, {
    message: 'Les mots de passe ne correspondent pas',
    path: ['confirmPassword'],
});
